export const listActions = `
   query listActions($filter: ActionsFilterInput, $limit: Int, $nextToken: String) {
       listActions(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              actionCode
              name
              applicationId
              status
              createdByUsername
              updatedByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getAction = `
   query getAction($id: ID!) {
       getAction(id: $id) {
         id
         actionCode
         name
         applicationId
         status
         createdByUsername
         updatedByUsername
         created
         updated
       }
}`;
